import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../Utils/toastContext";
import { useSelector, useDispatch } from "react-redux";

const ActivityLog = ({ onClose, customerId }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [expandedIndex, setExpandedIndex] = useState(null);
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const [isLoading, setIsLoading] = useState(true);

  const [filter, setFilter] = useState(0);
  const [filterUser, setFilterUser] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [historyData, setHistoryData] = useState([]);
  const [filterUserOptions, setFilterUserOptions] = useState([]);
  const [selectedDoc, setselectedDoc] = useState({});
  const [isFileOpen, setisFileOpen] = useState(false);
  const [isUsersLoading, setIsUsersLoading] = useState(true);
  const [isLogsLoading, setIsLogsLoading] = useState(true);
  const [isOverallLoading, setIsOverallLoading] = useState(true);
  // const historyData = [
  //   {
  //     added_by: {
  //       first_name: "Peter",
  //       last_name: "Yassa",
  //       role: "Customer",
  //       avatar: "/avatar.svg",
  //     },
  //     action_text: "has saved the Personal Details Section.",
  //     unique_id: "",
  //     uploaded_at: "2025-09-18T08:26:00",
  //     notes:
  //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //   },
  //   {
  //     added_by: {
  //       first_name: "John",
  //       last_name: "Anderson",
  //       role: "Onboarding Staff",
  //       avatar: "/avatar.svg",
  //     },
  //     action_text: "has edited the Email Personal Details Section.",
  //     unique_id: "",
  //     uploaded_at: "2025-09-18T19:34:00",
  //     notes: "",
  //   },
  //   {
  //     added_by: {
  //       first_name: "Jason",
  //       last_name: "Quinn",
  //       role: "Advisor",
  //       avatar: "/avatar.svg",
  //     },
  //     action_text: "has edited the Date of Birth Personal Details Section.",
  //     unique_id: "",
  //     uploaded_at: "2025-09-18T20:00:00",
  //     notes: "",
  //   },
  //   {
  //     added_by: {
  //       first_name: "Brian",
  //       last_name: "Vaughan",
  //       role: "Admin",
  //       avatar: "/avatar.svg",
  //     },
  //     action_text: "has edited the Address Personal Details Section.",
  //     unique_id: "",
  //     uploaded_at: "2025-09-17T19:34:00",
  //     notes: "",
  //   },
  //   {
  //     added_by: {
  //       first_name: "John",
  //       last_name: "Anderson",
  //       role: "Onboarding Staff",
  //       avatar: "/avatar.svg",
  //     },
  //     action_text: "has edited the Email Personal Details Section.",
  //     unique_id: "",
  //     uploaded_at: "2025-09-17T20:00:00",
  //     notes: "",
  //   },
  // ];
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 0,
    label: "All time",
  });
  const [preSelectedFilterUser, setpreSelectedFilterUser] = useState({});
  const navigate = useNavigate();
  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Format date groups
  const groupByDate = (data) => {
    const groups = {};
    data.forEach((item) => {
      const date = new Date(item.created_at).toDateString();
      if (!groups[date]) groups[date] = [];
      groups[date].push(item);
    });
    return groups;
  };

  const groupedData = groupByDate(historyData);
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setFilter(selectedOption.value);
    setpreSelectedFilter(selectedOption);
    const today = new Date();
    let startDate = new Date();

    if (selectedOption.value === 7) {
      // Last 7 days
      startDate.setDate(today.getDate() - 7);
    } else if (selectedOption.value === 30) {
      // Last 30 days
      startDate.setDate(today.getDate() - 30);
    }

    // Format as YYYY-MM-DD (or as your API expects)
    const formattedStart = startDate.toISOString().split("T")[0];
    const formattedEnd = today.toISOString().split("T")[0];

    setStartDate(formattedStart);
    setEndDate(formattedEnd);
  };
  const handleFilterChangeUser = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setFilterUser(selectedOption.value);
    setpreSelectedFilterUser(selectedOption);
  };
  const formatDateTime = (dateString) => {
    const [datePart, timePart, meridian, timezone] = dateString.split(" ");
    const [day, month, year] = datePart.split("/");
    const [hours, minutes] = timePart.split(":");

    // Convert 24-hour format to 12-hour format
    const hours12 = (+hours % 12 || 12).toString();
    const formattedTime = `${hours12}.${minutes}${meridian}`;
    return `${formattedTime} | ${day}/${month}/${year}`;
  };
  const filterOptions = [
    { value: 0, label: "All time" },
    { value: 7, label: "Last 7 days" },
    { value: 30, label: "Last 30 days" },
  ];
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getActivityLogs = async () => {
    try {
      let response = "";
      let baseUrl = `/v1/audit-logs/audit-logs?size=100&page=1&target_customer_id=${customerId}`;

      // Add user_id only if it's valid
      if (filterUser) {
        baseUrl += `&actor_id=${filterUser}`;
      }

      // Add date filters only if filter is not 0
      if (filter !== 0) {
        baseUrl += `&start_date=${startDate}&end_date=${endDate}`;
      }
      response = await GetAPIcalls(baseUrl);

      if (response.status == 200) {
        setHistoryData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setHistoryData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {}, 100);
    }
  };
  const getUsers = async () => {
    try {
      setIsLoading(true);
      let response = "";
      response = await GetAPIcalls(loggedInUserRole=="advisor"?`/v1/advisor/user/customers`:`/v1/user/admin/users`);

      if (response.status == 200) {
        const users = [];
        users.push({
          value: null,
          label: "All Users",
        });
        response.data.users.forEach((profile) => {
          users.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
          });
        });
        setFilterUserOptions(users);
        setpreSelectedFilterUser(users[0]);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setFilterUserOptions([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };

  useEffect(() => {
    const fetchUsers = async () => {
      setIsUsersLoading(true);
      await getUsers();
      setIsUsersLoading(false);
    };

    const fetchLogs = async () => {
      setIsLogsLoading(true);
      await getActivityLogs();
      setIsLogsLoading(false);
    };

    fetchUsers();
    fetchLogs();
  }, [customerId]);

  useEffect(() => {
    // Recalculate overall loading whenever one of them changes
    setIsOverallLoading(isUsersLoading || isLogsLoading);
  }, [isUsersLoading, isLogsLoading]);

  useEffect(() => {
    // When filters change, only re-fetch activity logs, not users
    const fetchFilteredLogs = async () => {
      setIsLogsLoading(true);
      await getActivityLogs();
      setIsLogsLoading(false);
    };
    fetchFilteredLogs();
  }, [loggedInUserRole, filterUser, filter, startDate, endDate]);
  return (
    <div className=" fixed inset-0 flex  items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="my-4 bg-white rounded-lg shadow-lg w-[90%] max-w-3xl p-6 relative  h-[90vh] overflow-auto md:overflow-hidden">
        {/* Header */}

        <div className="flex items-center justify-between mb-6">
          {/* Heading with Icon */}
          <div className="flex items-center space-x-2">
            <img
              src="/backward-10-seconds.svg"
              alt="Document Icon"
              className="h-6 w-6"
            />
            <h2 className="text-lg font-medium">Activity Feed</h2>
          </div>

          <div className="flex items-center space-x-4">
            {/* Filter Dropdown */}
            {!isUsersLoading && filterUserOptions.length > 0 && (
              <Dropdown
                label=""
                options={filterUserOptions}
                preselectedValue={preSelectedFilterUser}
                search={true}
                onSelect={handleFilterChangeUser}
              />
            )}
            <Dropdown
              label=""
              options={filterOptions}
              preselectedValue={preSelectedFilter}
              onSelect={handleFilterChange}
            />
            {/* <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              className="border font-medium rounded-lg px-3 py-1 text-sm"
            >
              {filterOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select> */}

            {/* Close Button */}
            <button
              onClick={onClose}
              className="text-black text-xl font-bold hover:text-gray-700 flex items-center space-x-2"
            >
              {/* Icon */}
              <img src="/add.svg" alt="Close Icon" className="h-10 w-10" />
            </button>
          </div>
        </div>
        {/* History Items */}
        {isOverallLoading ? (
          // Shimmer Loader
          Array.from({ length: 5 }).map((_, index) => (
            <div
              key={index}
              className="p-4 rounded-md bg-gray-100 animate-pulse space-y-3"
            >
              <div className="flex items-start space-x-3">
                <div className="h-10 w-10 rounded-full bg-gray-300"></div>
                <div className="flex-1 space-y-2 py-1">
                  <div className="h-3 bg-gray-300 rounded w-1/2"></div>
                  <div className="h-3 bg-gray-300 rounded w-1/4"></div>
                </div>
              </div>
            </div>
          ))
        ) : Object.keys(groupedData).length === 0 ? (
          // 💤 No Activity Found
          <div className="flex flex-col items-center justify-center h-full text-black">
            <p className="text-sm sm:text-base font-medium">
              No activity found
            </p>
          </div>
        ) : (
          <div className="space-y-6 h-[60vh] overflow-y-auto px-2 mb-4">
            {Object.entries(groupedData).map(([date, items], groupIndex) => (
              <div key={groupIndex} className="space-y-3">
                {/* Date Divider */}
                <div className="relative flex items-center justify-center">
                  <div className="absolute w-full border-t border-gray-300"></div>
                  <span className="relative bg-white rounded-full font-semibold px-4 text-black border text-sm font-medium">
                    {date === "today"
                      ? "Today"
                      : date === "yesterday"
                      ? "Yesterday"
                      : date}
                  </span>
                </div>

                {/* Items */}
                {items.map((item, index) => (
                  <div
                    key={index}
                    className={`p-4 rounded-md ${
                      index % 2 === 0 ? "bg-blue-50" : "bg-gray-50"
                    }`}
                  >
                    <div className="flex items-start justify-between">
                      {/* Left: Avatar + Content */}
                      <div className="flex items-start space-x-3">
                        {/* Avatar */}
                        <img
                          src={item.actor.profile_image || "/avatar.svg"}
                          alt="User Avatar"
                          className="h-10 w-10 rounded-full border"
                        />

                        {/* Text */}
                        <div>
                          <p className="text-sm">
                            <span className="font-medium">
                              {item.actor.name}
                            </span>{" "}
                            <span className="text-[#3047EC] font-medium">
                              {item.actor.role}
                            </span>{" "}
                            <span className="text-sm text-[#919191]">
                              {item.formatted_description
                                ?.substring(
                                  item.formatted_description.indexOf("has")
                                )
                                .split(/'([^']+)'/)
                                .map((part, index) =>
                                  index % 2 === 1 ? (
                                    <span key={index} className="text-black">
                                      {part}
                                    </span>
                                  ) : (
                                    <span key={index}>{part}</span>
                                  )
                                )}
                            </span>
                            {/* <span className="font-medium">{item.id}</span> */}
                          </p>

                          {/* Time */}
                          <p className="text-xs mt-2 text-gray-500 flex items-center space-x-2">
                            <img
                              src="/clock-black.svg"
                              alt="Time Icon"
                              className="h-4 w-4"
                            />
                            <span>
                              {new Date(item.created_at).toLocaleTimeString(
                                [],
                                {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                }
                              )}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}

        {/* Footer */}
        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="bg-white border-black border  text-black px-10 py-2 rounded-full"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivityLog;
